export default __webpack_public_path__ + "static/media/director.c07e7a5b.svg";